export default __webpack_public_path__ + "static/media/monitors.c901afb7.svg";